import React, { createContext, useState } from 'react';

export const SalesContext = createContext();

export const SalesProvider = ({ children }) => {
  const [totalSales, setTotalSales] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const updateTotalSales = (count) => {
    try {
      setLoading(true);
      setTotalSales(count);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <SalesContext.Provider 
      value={{ 
        totalSales, 
        updateTotalSales,
        loading,
        error
      }}
    >
      {children}
    </SalesContext.Provider>
  );
}; 